import { render, staticRenderFns } from "./RegisterCompletePage.vue?vue&type=template&id=72ae3104&scoped=true&"
import script from "./RegisterCompletePage.vue?vue&type=script&lang=ts&"
export * from "./RegisterCompletePage.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterCompletePage.vue?vue&type=style&index=0&id=72ae3104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ae3104",
  null
  
)

export default component.exports